import { ArrowUpOutlined } from "@ant-design/icons";
import { Button, Row, Typography } from "antd";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import EarthIcon from "../../assets/images/earth.webp";
import PaymentIcons from "../../assets/images/payMethods.webp";
import languageUtil from "../../utls/LanguageUtil";
import SelectComponent from "../SelectComponent";
import "./index.less";

const { Text } = Typography;

const Footer = ({ hideElement = [], hideFooter = false }: { hideElement?: string[]; hideFooter?: boolean }) => {
  const contactArr = [
    { name: "contact", href: "/contact" },
    { name: "legal-notices", href: "/legal-notices" },
    { name: "content-policy-and-child-protection-text", href: "/content-policy-and-child-protection" },
    { name: "confidentiality", href: "/confidentiality-and-data-protection" },
    { name: "general-conditions-of-sale", href: "/general-conditions-of-sale" },
    { name: "general-conditions-of-use", href: "/general-conditions-of-use" },
    { name: "blog", href: "/blogs" },
  ];

  const { i18n, t } = useTranslation();
  const [languageValue, setLanguageValue] = useState<string>(languageUtil.getPublicCurrentLanguage());

  const changedLanguage = async (value: string) => {
    await languageUtil.setCurrentLanguage(i18n, value);
    setLanguageValue(languageUtil.getPublicCurrentLanguage());
  };

  return (
    <Row className="footer_main" justify="center">
      <footer className="footer-container">
        <Link to="/auth/signUp">
          <Button className="explore-button" type="primary">
            <Text className="explore-text">{t("explore-twizz")}</Text>
            <div className="arrow-icon-wrapper">
              <ArrowUpOutlined className="arrow-icon" />
            </div>
          </Button>
        </Link>
        <div className="contact-list">
          {contactArr
            ?.filter((item) => !hideElement?.includes(item?.name))
            ?.map((item, index) => (
              <Link to={item?.href}>
                <div key={index} className="contact-item">
                  <Text className="chaild">{t(item?.name)}</Text>
                  <Button className="arrow-button" icon={<ArrowUpOutlined className="arrow-icon2" />} />
                </div>
              </Link>
            ))}
        </div>
        {!hideFooter && (
          <>
            <div className="footer-images">
              <img src={EarthIcon} alt="Earth" className="earth-image" />
              <img src={PaymentIcons} alt="Payment Methods" className="payment-methods-image" />
            </div>
            <Row className="justify-content-center">
              <SelectComponent
                className="authLanguage"
                defaultValue={languageUtil.DEFAULT_LANGUAGE}
                value={languageValue}
                options={languageUtil.AVAILABLE_LANGUAGES_OPTIONS}
                onSelect={changedLanguage}
              />
            </Row>
          </>
        )}

        {/* SEO: Link for crawlers */}
        <details>
          <summary style={{ listStyle: "none" }}></summary>
          <a href="/profiles">Creator Profiles</a>
        </details>
      </footer>
    </Row>
  );
};

export default Footer;
